const FarmPractices = [
// Weed Control Fields
    {
        id: 1.01,
        section: 'weed_control',
        field: 'Plot',
        field_key: 'plot_id', //to be filled as per the key name in API
        type: 'dropdown',
    },
    {
        id: 1.02,
        section: 'weed_control',
        field: 'Crop',
        field_key: 'crop_id',
        type: 'dropdown',
    },
    {
        id: 1.03,
        section: 'weed_control',
        field: 'Weed control name',
        field_key: 'weed_control_name',
        type: 'dropdown',
    },
    {
        id: 1.04,
        section: 'weed_control',
        field: 'Weed control source',
        field_key: 'weed_control_source',
        type: 'dropdown',
    },
    {
        id: 1.05,
        section: 'weed_control',
        field: 'Weed control method used',
        field_key: 'weed_control_method',
        type: 'dropdown',
    },
    {
        id: 1.06,
        section: 'weed_control',
        field: 'Quantity of weed control purchased',
        field_key: 'purchase_quantity',
        type: 'numeric',
    },
    {
        id: 1.07,
        section: 'weed_control',
        field: 'Amount paid for weed control purchase',
        field_key: 'purchase_amount',
        type: 'numeric',
    },
    {
        id: 1.16,
        section: 'weed_control',
        field: 'Weed control purchase date',
        field_key: 'purchase_date',
        type: 'date',
    },
    {
        id: 1.08,
        section: 'weed_control',
        field: 'Date of application',
        field_key: 'date_of_application',
        type: 'date',
    },
    {
        id: 1.15,
        section: 'weed_control',
        field: 'Total quantity used',
        field_key: 'quantity_used',
        type: 'numeric',
    },
    {
        id: 1.16,
        section: 'weed_control',
        field: 'UOM of quantity',
        field_key: 'quantity_unit',
        type: 'dropdown',
    },
    {
        id: 1.09,
        section: 'weed_control',
        field: 'Number of labours (Male)',
        field_key: 'no_male_workers',
        type: 'numeric',
    },
    {
        id: 1.10,
        section: 'weed_control',
        field: 'Number of labours (Female)',
        field_key: 'no_female_workers',
        type: 'numeric',
    },
    {
        id: 1.11,
        section: 'weed_control',
        field: 'Date of activity',
        field_key: 'activity_work_date',
        type: 'date',
    },
    {
        id: 1.12,
        section: 'weed_control',
        field: 'Number of hours worked',
        field_key: 'hours_worked',
        type: 'text',
    },
    {
        id: 1.13,
        section: 'weed_control',
        field: 'Total amount paid',
        field_key: 'total_amount_paid',
        type: 'numeric',
    },

    {
        id: 1.14,
        section: 'weed_control',
        field: 'Machinery details',
        field_key: 'machinery_usage',
        type: 'table',
        table_headers: ['Machinery used', 'Machinery Usage hours', 'Machinery cost', 'Machinery usage date'],
        table_body: [
            {
                name: 'machinery_used',
                type: 'dropdown',
                field_key: 'machinery_used',
            }, 
            {
                name: 'machinery_usage_hours',
                type: 'numeric',
                field_key: 'machinery_usage_hours',
            },
            {
                name: 'machinery_cost',
                type: 'numeric',
                field_key: 'machinery_cost'
            }, 
            {
                name: 'machinery_use_date',
                type: 'date',
                field_key: 'machinery_use_date'
            },
        ]
    },

// Pest Control Fields
    {
        id: 2.01,
        section: 'pest_control',
        field: 'Plot',
        field_key: 'plot_id', //to be filled as per the key name in API
        type: 'dropdown',
    },
    {
        id: 2.02,
        section: 'pest_control',
        field: 'Crop',
        field_key: 'crop_id',
        type: 'dropdown',
    },
    {
        id: 2.03,
        section: 'pest_control',
        field: 'Pest control name',
        field_key: 'pest_control_name',
        type: 'dropdown',
    },
    {
        id: 2.04,
        section: 'pest_control',
        field: 'Pest control source',
        field_key: 'pest_control_source',
        type: 'dropdown',
    },
    {
        id: 2.05,
        section: 'pest_control',
        field: 'Pest control method',
        field_key: 'pest_control_method',
        type: 'dropdown',
    },
    {
        id: 2.06,
        section: 'pest_control',
        field: 'Quantity of pest control purchased',
        field_key: 'purchase_quantity',
        type: 'numeric',
    },
    {
        id: 2.07,
        section: 'pest_control',
        field: 'Amount paid for pest control purchase',
        field_key: 'purchase_amount',
        type: 'numeric',
    },
    {
        id: 2.17,
        section: 'pest_control',
        field: 'Pest control purchase date',
        field_key: 'purchase_date',
        type: 'date',
    },
    {
        id: 2.08,
        section: 'pest_control',
        field: 'Application type',
        field_key: 'application_type',
        type: 'dropdown',
    },
    {
        id: 2.18,
        section: 'pest_control',
        field: 'Date of application',
        field_key: 'date_of_application',
        type: 'date',
    },
    {
        id: 2.15,
        section: 'pest_control',
        field: 'Total quantity used',
        field_key: 'quantity_used',
        type: 'numeric',
    },
    {
        id: 2.16,
        section: 'pest_control',
        field: 'UOM of quantity',
        field_key: 'quantity_unit',
        type: 'dropdown',
    },
    {
        id: 2.09,
        section: 'pest_control',
        field: 'Number of labours (Male)',
        field_key: 'no_male_workers',
        type: 'numeric',
    },
    {
        id: 2.10,
        section: 'pest_control',
        field: 'Number of labours (Female)',
        field_key: 'no_female_workers',
        type: 'numeric',
    },
    {
        id: 2.11,
        section: 'pest_control',
        field: 'Date of activity',
        field_key: 'activity_work_date',
        type: 'date',
    },
    {
        id: 2.12,
        section: 'pest_control',
        field: 'Number of hours worked',
        field_key: 'hours_worked',
        type: 'text',
    },
    {
        id: 2.13,
        section: 'pest_control',
        field: 'Total amount paid',
        field_key: 'total_amount_paid',
        type: 'numeric',
    },

    {
        id: 2.14,
        section: 'pest_control',
        field: 'Machinery details',
        field_key: 'machinery_usage',
        type: 'table',
        table_headers: ['Machinery used', 'Machinery Usage hours', 'Machinery cost', 'Machinery usage date'],
        table_body: [
            {
                name: 'machinery_used',
                type: 'dropdown',
                field_key: 'machinery_used',
            }, 
            {
                name: 'machinery_usage_hours',
                type: 'numeric',
                field_key: 'machinery_usage_hours',
            },
            {
                name: 'machinery_cost',
                type: 'numeric',
                field_key: 'machinery_cost'
            }, 
            {
                name: 'machinery_use_date',
                type: 'date',
                field_key: 'machinery_use_date'
            },
        ]
    },

// Fertilizer Application Fields
    {
        id: 3.01,
        section: 'fertilizer_application',
        field: 'Plot',
        field_key: 'plot_id', //to be filled as per the key name in API
        type: 'dropdown',
    },
    {
        id: 3.02,
        section: 'fertilizer_application',
        field: 'Crop',
        field_key: 'crop_id',
        type: 'dropdown',
    },
    {
        id: 3.03,
        section: 'fertilizer_application',
        field: 'Fertilizer name',
        field_key: 'fertilizer_name',
        type: 'dropdown',
    },
    
    {
        id: 3.18,
        section: 'fertilizer_application',
        field: 'Fertilizer type',
        field_key: 'fertilizer_type',
        type: 'dropdown',
    },
    {
        id: 3.05,
        section: 'fertilizer_application',
        field: 'Preparation method',
        field_key: 'preparation_method',
        type: 'dropdown',
        dependent_field: 'fertilizer_type',
        dependent_value: 'own',
    },
    {
        id: 3.19,
        section: 'fertilizer_application',
        field: 'Preparation date',
        field_key: 'preparation_date',
        type: 'date',
        dependent_field: 'fertilizer_type',
        dependent_value: 'own',
    },
    {
        id: 3.04,
        section: 'fertilizer_application',
        field: 'Fertilizer source',
        field_key: 'fertilizer_source',
        type: 'dropdown',
        dependent_field: 'fertilizer_type',
        dependent_value: 'purchased',
    },
    {
        id: 3.06,
        section: 'fertilizer_application',
        field: 'Quantity of fertilizer purchased',
        field_key: 'purchase_quantity',
        type: 'numeric',
        dependent_field: 'fertilizer_type',
        dependent_value: 'purchased',
    },
    {
        id: 3.07,
        section: 'fertilizer_application',
        field: 'Amount paid for fertilizer purchase',
        field_key: 'purchase_amount',
        type: 'numeric',
        dependent_field: 'fertilizer_type',
        dependent_value: 'purchased',
    },
    {
        id: 3.16,
        section: 'fertilizer_application',
        field: 'Place of fertilizer purchase',
        field_key: 'purchased_from',
        type: 'text',
        dependent_field: 'fertilizer_type',
        dependent_value: 'purchased',
    },
    {
        id: 3.17,
        section: 'fertilizer_application',
        field: 'Date of fertilizer purchase',
        field_key: 'purchase_date',
        type: 'date',
        dependent_field: 'fertilizer_type',
        dependent_value: 'purchased',
    },
    {
        id: 3.20,
        section: 'fertilizer_application',
        field: 'Quantity used',
        field_key: 'quantity_used',
        type: 'numeric',
    },
    {
        id: 3.21,
        section: 'fertilizer_application',
        field: 'UOM of Quantity',
        field_key: 'quantity_unit',
        type: 'dropdown',
    },
    {
        id: 3.09,
        section: 'fertilizer_application',
        field: 'Date of application',
        field_key: 'date_of_application',
        type: 'date',
    },
    {
        id: 3.08,
        section: 'fertilizer_application',
        field: 'Any restricted items used with approval',
        field_key: 'restricted_items_usage',
        type: 'dropdown',
    },
    {
        id: 3.22,
        section: 'fertilizer_application',
        field: 'Reason for usage',
        field_key: 'usage_reason',
        type: 'text',
        dependent_field: 'restricted_items_usage',
        dependent_value: 'true',
    },
    {
        id: 3.23,
        section: 'fertilizer_application',
        field: 'Application suggestion',
        field_key: 'application_suggestion',
        type: 'dropdown',
        dependent_field: 'restricted_items_usage',
        dependent_value: 'true',
    },
    {
        id: 3.24,
        section: 'fertilizer_application',
        field: 'Soil test details',
        field_key: 'soil_test_details',
        type: 'table',
        dependent_field: 'restricted_items_usage',
        dependent_value: 'true',
        table_headers: ['Nitrogen', 'Potassium', 'Phosphorous', 'ph', 'Moisture', 'Temperature', 'Testing date', 'Advisory'],
        table_body: [
            { name: 'nitrogen', type: 'numeric', field_key: 'nitrogen',}, 
            { name: 'potassium', type: 'numeric', field_key: 'potassium',},
            { name: 'phosphorous', type: 'numeric', field_key: 'phosphorous'}, 
            { name: 'ph', type: 'numeric', field_key: 'ph'},
            { name: 'moisture', type: 'numeric', field_key: 'moisture'},
            { name: 'temperature', type: 'numeric', field_key: 'temperature'},
            { name: 'testing_date', type: 'date', field_key: 'testing_date'},
            { name: 'advisory', type: 'text', field_key: 'advisory'},
        ]
    },
    {
        id: 3.10,
        section: 'fertilizer_application',
        field: 'Number of labours (Male)',
        field_key: 'no_male_workers',
        type: 'numeric',
    },
    {
        id: 3.11,
        section: 'fertilizer_application',
        field: 'Number of labours (Female)',
        field_key: 'no_female_workers',
        type: 'numeric',
    },
    {
        id: 3.12,
        section: 'fertilizer_application',
        field: 'Date of activity',
        field_key: 'activity_work_date',
        type: 'date',
    },
    {
        id: 3.13,
        section: 'fertilizer_application',
        field: 'Number of hours worked',
        field_key: 'hours_worked',
        type: 'text',
    },
    {
        id: 3.14,
        section: 'fertilizer_application',
        field: 'Total amount paid',
        field_key: 'total_amount_paid',
        type: 'numeric',
    },
    {
        id: 3.25,
        section: 'fertilizer_application',
        field: 'Application method',
        field_key: 'application_application_method',
        type: 'dropdown',
    },
    {
        id: 3.15,
        section: 'fertilizer_application',
        field: 'Machinery details',
        field_key: 'machinery_usage',
        type: 'table',
        dependent_field: 'application_application_method',
        dependent_value: 'machinery',
        table_headers: ['Machinery used', 'Machinery Usage hours', 'Machinery cost', 'Machinery usage date'],
        table_body: [
            {
                name: 'machinery_used',
                type: 'dropdown',
                field_key: 'machinery_used',
            }, 
            {
                name: 'machinery_usage_hours',
                type: 'numeric',
                field_key: 'machinery_usage_hours',
            },
            {
                name: 'machinery_cost',
                type: 'numeric',
                field_key: 'machinery_cost'
            }, 
            {
                name: 'machinery_use_date',
                type: 'date',
                field_key: 'machinery_use_date'
            },
        ]
    },

// Irrigation Fields
    {
        id: 4.01,
        section: 'irrigation',
        field: 'Plot',
        field_key: 'plot_id', //to be filled as per the key name in API
        type: 'dropdown',
    },
    {
        id: 4.02,
        section: 'irrigation',
        field: 'Crop',
        field_key: 'crop_id',
        type: 'dropdown',
    },
    // {
    //     id: 4.03,
    //     section: 'irrigation',
    //     field: 'Rain-fed',
    //     field_key: '',
    //     type: 'bool',
    // },
    {
        id: 4.04,
        section: 'irrigation',
        field: 'Type of irrigation -  Rain fed / Manual',
        field_key: 'is_rainfed',
        type: 'dropdown', 
    },
    {
        id: 4.05,
        section: 'irrigation',
        field: 'Method of irrigation',
        field_key: 'irrigation_method',
        type: 'dropdown', // dropdown values : borewell, canal wells etc from xmind  
        dependent_field: 'is_rainfed',
        dependent_value: 'false'
    },
    {
        id: 4.16,
        section: 'irrigation',
        field: 'Irrigation source',
        field_key: 'irrigation_source',
        type: 'dropdown',
        dependent_field: 'is_rainfed',
        dependent_value: 'false'
    },
    {
        id: 4.07,
        section: 'irrigation',
        field: 'Number of hours of irrigation',
        field_key: 'irrigation_duration',
        type: 'numeric',
        dependent_field: 'is_rainfed',
        dependent_value: 'false'
    },
    {
        id: 4.08,
        section: 'irrigation',
        field: 'Amount spent for irrigation',
        field_key: 'amount_spent',
        type: 'numeric',
        dependent_field: 'is_rainfed',
        dependent_value: 'false'
    },
    {
        id: 4.09,
        section: 'irrigation',
        field: 'Date of irrigation',
        field_key: 'date_of_irrigation',
        type: 'date',
        dependent_field: 'is_rainfed',
        dependent_value: 'false'
    },
    {
        id: 4.10,
        section: 'irrigation',
        field: 'Number of labours (Male)',
        field_key: 'no_male_workers',
        type: 'numeric',
    },
    {
        id: 4.11,
        section: 'irrigation',
        field: 'Number of labours (Female)',
        field_key: 'no_female_workers',
        type: 'numeric',
    },
    {
        id: 4.12,
        section: 'irrigation',
        field: 'Date of activity',
        field_key: 'activity_work_date',
        type: 'date',
    },
    {
        id: 4.13,
        section: 'irrigation',
        field: 'Number of hours worked',
        field_key: 'hours_worked',
        type: 'text',
    },
    {
        id: 4.14,
        section: 'irrigation',
        field: 'Total amount paid',
        field_key: 'total_amount_paid',
        type: 'numeric',
    },
    {
        id: 4.06,
        section: 'irrigation',
        field: 'Machinery used',
        field_key: 'is_machinery_used',
        type: 'dropdown',
        dependent_field: 'is_rainfed',
        dependent_value: 'false'
    },
    {
        id: 4.15,
        section: 'irrigation',
        field: 'Machinery details',
        field_key: 'machinery_usage',
        type: 'table',
        dependent_field: 'is_machinery_used',
        dependent_value: 'true',
        table_headers: ['Machinery used', 'Machinery Usage hours', 'Machinery cost', 'Machinery usage date'],
        table_body: [
            {
                name: 'machinery_used',
                type: 'dropdown',
                field_key: 'machinery_used',
            }, 
            {
                name: 'machinery_usage_hours',
                type: 'numeric',
                field_key: 'machinery_usage_hours',
            },
            {
                name: 'machinery_cost',
                type: 'numeric',
                field_key: 'machinery_cost'
            }, 
            {
                name: 'machinery_use_date',
                type: 'date',
                field_key: 'machinery_use_date'
            },
        ]
    },

//Land preparation fields
    {
        id: 5.01,
        section: 'land_preparation',
        field: 'Plot',
        field_key: 'plot_id', //to be filled as per the key name in API
        type: 'dropdown',
    },
    {
        id: 5.02,
        section: 'land_preparation',
        field: 'Date of Land Preparation',
        field_key: 'land_preparation_date', //to be filled as per the key name in API
        type: 'date',
    },
    {
        id: 5.10,
        section: 'land_preparation',
        field: 'Soil test details',
        field_key: 'soil_test_details',
        type: 'table',
        table_headers: ['Nitrogen', 'Potassium', 'Phosphorous', 'ph', 'Moisture', 'Temperature', 'Testing date', 'Advisory'],
        table_body: [
            { name: 'nitrogen', type: 'numeric', field_key: 'nitrogen',}, 
            { name: 'potassium', type: 'numeric', field_key: 'potassium',},
            { name: 'phosphorous', type: 'numeric', field_key: 'phosphorous'}, 
            { name: 'ph', type: 'numeric', field_key: 'ph'},
            { name: 'moisture', type: 'numeric', field_key: 'moisture'},
            { name: 'temperature', type: 'numeric', field_key: 'temperature'},
            { name: 'testing_date', type: 'date', field_key: 'testing_date'},
            { name: 'advisory', type: 'text', field_key: 'advisory'},
        ]
    },
    {
        id: 5.04,
        section: 'land_preparation',
        field: 'Number of labours (Male)',
        field_key: 'no_male_workers',
        type: 'numeric',
    },
    {
        id: 5.05,
        section: 'land_preparation',
        field: 'Number of labours (Female)',
        field_key: 'no_female_workers',
        type: 'numeric',
    },
    {
        id: 5.06,
        section: 'land_preparation',
        field: 'Date of activity',
        field_key: 'activity_work_date',
        type: 'date',
    },
    {
        id: 5.07,
        section: 'land_preparation',
        field: 'Number of hours worked',
        field_key: 'hours_worked',
        type: 'text',
    },
    {
        id: 5.08,
        section: 'land_preparation',
        field: 'Total amount paid',
        field_key: 'total_amount_paid',
        type: 'numeric',
    },
    {
        id: 5.03,
        section: 'land_preparation',
        field: 'Method of land preparation',
        field_key: 'land_preparation_method', //to be filled as per the key name in API
        type: 'dropdown',
    },
    {
        id: 5.09,
        section: 'land_preparation',
        field: 'Machinery details',
        field_key: 'machinery_usage',
        type: 'table',
        dependent_field: 'land_preparation_method',
        dependent_value: 'machinery',
        table_headers: ['Machinery used', 'Machinery Usage hours', 'Machinery cost', 'Machinery usage date'],
        table_body: [
            {
                name: 'machinery_used',
                type: 'dropdown',
                field_key: 'machinery_used',
            }, 
            {
                name: 'machinery_usage_hours',
                type: 'numeric',
                field_key: 'machinery_usage_hours',
            },
            {
                name: 'machinery_cost',
                type: 'numeric',
                field_key: 'machinery_cost'
            }, 
            {
                name: 'machinery_use_date',
                type: 'date',
                field_key: 'machinery_use_date'
            },
        ]
    },

//Nursery fields
    {
        id: 6.01,
        section: 'nursery',
        field: 'Plot',
        field_key: 'plot_id',
        type: 'dropdown',
    },
    {
        id: 6.02,
        section: 'nursery',
        field: 'Crop',
        field_key: 'crop_id',
        type: 'dropdown',
    },
    {
        id: 6.14,
        section: 'nursery',
        field: 'Seed variety',
        field_key: 'variety',
        type: 'text',
    },
    {
        id: 6.03,
        section: 'nursery',
        field: 'Seed preparation method',
        field_key: 'seed_preparation_method',
        type: 'dropdown',
    },
    {
        id: 6.04,
        section: 'nursery',
        field: 'Seed purchase date',
        field_key: 'purchase_date',
        type: 'date',
        dependent_field: 'seed_preparation_method',
        dependent_value: 'purchased',
    },
    {
        id: 6.05,
        section: 'nursery',
        field: 'Purchased from',
        field_key: 'purchased_from',
        type: 'text',
        dependent_field: 'seed_preparation_method',
        dependent_value: 'purchased',
    },
    {
        id: 6.06,
        section: 'nursery',
        field: 'Purchase quantity',
        field_key: 'purchase_quantity',
        type: 'numeric',
        dependent_field: 'seed_preparation_method',
        dependent_value: 'purchased',
    },
    {
        id: 6.07,
        section: 'nursery',
        field: 'UOM of quantity',
        field_key: 'quantity_unit',
        type: 'dropdown',
        dependent_field: 'seed_preparation_method',
        dependent_value: 'purchased',
    },
    {
        id: 6.08,
        section: 'nursery',
        field: 'Purchase amount',
        field_key: 'purchase_amount',
        type: 'numeric',
        dependent_field: 'seed_preparation_method',
        dependent_value: 'purchased',
    },
    {
        id: 6.15,
        section: 'nursery',
        field: 'Quantity utilized',
        field_key: 'quantity_used',
        type: 'text',
    },
    {
        id: 6.09,
        section: 'nursery',
        field: 'Number of labours (Male)',
        field_key: 'no_male_workers',
        type: 'numeric',
    },
    {
        id: 6.10,
        section: 'nursery',
        field: 'Number of labours (Female)',
        field_key: 'no_female_workers',
        type: 'numeric',
    },
    {
        id: 6.11,
        section: 'nursery',
        field: 'Date of activity',
        field_key: 'activity_work_date',
        type: 'date',
    },
    {
        id: 6.12,
        section: 'nursery',
        field: 'Number of hours worked',
        field_key: 'hours_worked',
        type: 'text',
    },
    {
        id: 6.13,
        section: 'nursery',
        field: 'Total amount paid',
        field_key: 'total_amount_paid',
        type: 'numeric',
    },

//Sowing/Planting fields
    {
        id: 7.01,
        section: 'sowing',
        field: 'Plot',
        field_key: 'plot_id',
        type: 'dropdown',
    },
    {
        id: 7.02,
        section: 'sowing',
        field: 'Crop',
        field_key: 'crop_id',
        type: 'dropdown',
    },
    {
        id: 7.09,
        section: 'sowing',
        field: 'Crop variety',
        field_key: 'crop_variety',
        type: 'text',
    },
    {
        id: 7.03,
        section: 'sowing',
        field: 'Sowing/Planting Date',
        field_key: 'sowing_planting_date',
        type: 'date',
    },
    {
        id: 7.04,
        section: 'sowing',
        field: 'Number of labours (Male)',
        field_key: 'no_male_workers',
        type: 'numeric',
    },
    {
        id: 7.05,
        section: 'sowing',
        field: 'Number of labours (Female)',
        field_key: 'no_female_workers',
        type: 'numeric',
    },
    {
        id: 7.06,
        section: 'sowing',
        field: 'Date of activity',
        field_key: 'activity_work_date',
        type: 'date',
    },
    {
        id: 7.07,
        section: 'sowing',
        field: 'Number of hours worked',
        field_key: 'hours_worked',
        type: 'text',
    },
    {
        id: 7.08,
        section: 'sowing',
        field: 'Total amount paid',
        field_key: 'total_amount_paid',
        type: 'numeric',
    },

//Composting fields
    {
        id: 8.01,
        section: 'composting',
        field: 'Plot',
        field_key: 'plot_id',
        type: 'dropdown',
    },
    {
        id: 8.02,
        section: 'composting',
        field: 'Crop',
        field_key: 'crop_id',
        type: 'dropdown',
    },
    {
        id: 8.03,
        section: 'composting',
        field: 'Composting type',
        field_key: 'composting_type',
        type: 'dropdown',
    },
    {
        id: 8.04,
        section: 'composting',
        field: 'Date of preparation',
        field_key: 'preparation_date',
        type: 'date',
    },
    {
        id: 8.13,
        section: 'composting',
        field: 'Method of preparation',
        field_key: 'preparation_method',
        type: 'dropdown',
    },
    {
        id: 8.05,
        section: 'composting',
        field: 'Temperature details in degree celsius',
        field_key: 'temperature',
        type: 'numeric',
    },
    {
        id: 8.06,
        section: 'composting',
        field: 'Date of collection',
        field_key: 'date_of_collection',
        type: 'date',
    },
    {
        id: 8.14,
        section: 'composting',
        field: 'Amount spent',
        field_key: 'amount_spent',
        type: 'numeric',
    },    
    {
        id: 8.07,
        section: 'composting',
        field: 'Quantity utilized',
        field_key: 'quantity_used',
        type: 'numeric',
    },
    {
        id: 8.15,
        section: 'composting',
        field: 'UOM of quantity',
        field_key: 'quantity_unit',
        type: 'dropdown',
    },
    {
        id: 8.08,
        section: 'composting',
        field: 'Number of labours (Male)',
        field_key: 'no_male_workers',
        type: 'numeric',
    },
    {
        id: 8.09,
        section: 'composting',
        field: 'Number of labours (Female)',
        field_key: 'no_female_workers',
        type: 'numeric',
    },
    {
        id: 8.10,
        section: 'composting',
        field: 'Date of activity',
        field_key: 'activity_work_date',
        type: 'date',
    },
    {
        id: 8.11,
        section: 'composting',
        field: 'Number of hours worked',
        field_key: 'hours_worked',
        type: 'text',
    },
    {
        id: 8.12,
        section: 'composting',
        field: 'Total amount paid',
        field_key: 'total_amount_paid',
        type: 'numeric',
    },
    {
        id: 8.16,
        section: 'composting',
        field: 'Application method',
        field_key: 'application_method',
        type: 'dropdown',
    },
    {
        id: 8.17,
        section: 'composting',
        field: 'Machinery details',
        field_key: 'machinery_usage',
        type: 'table',
        dependent_field: 'application_method',
        dependent_value: 'machinery',
        table_headers: ['Machinery used', 'Machinery Usage hours', 'Machinery cost', 'Machinery usage date'],
        table_body: [
            {
                name: 'machinery_used',
                type: 'dropdown',
                field_key: 'machinery_used',
            }, 
            {
                name: 'machinery_usage_hours',
                type: 'numeric',
                field_key: 'machinery_usage_hours',
            },
            {
                name: 'machinery_cost',
                type: 'numeric',
                field_key: 'machinery_cost'
            }, 
            {
                name: 'machinery_use_date',
                type: 'date',
                field_key: 'machinery_use_date'
            },
        ]
    },

//Harvesting fields
    {
        id: 9.01,
        section: 'harvesting',
        field: 'Plot',
        field_key: 'plot_id',
        type: 'dropdown',
    },
    {
        id: 9.02,
        section: 'harvesting',
        field: 'Crop',
        field_key: 'crop_id',
        type: 'dropdown',
    },
    {
        id: 9.03,
        section: 'harvesting',
        field: 'Date of harvesting',
        field_key: 'harvesting_date',
        type: 'date',
    },
    {
        id: 9.04,
        section: 'harvesting',
        field: 'Quantity harvested / Yield',
        field_key: 'harvest_quantity',
        type: 'numeric',
    },
    {
        id: 9.05,
        section: 'harvesting',
        field: 'Quantity sold',
        field_key: 'sale_quantity',
        type: 'numeric',
    },
    {
        id: 9.06,
        section: 'harvesting',
        field: 'Quantity stocked',
        field_key: 'quantity_stocked',
        type: 'numeric',
    },
    {
        id: 9.15,
        section: 'harvesting',
        field: 'Quantity for self use',
        field_key: 'self_use_quantity',
        type: 'numeric',
    },
    {
        id: 9.09,
        section: 'harvesting',
        field: 'UOM for quantity',
        field_key: 'quantity_unit',
        type: 'numeric',
    },
    {
        id: 9.10,
        section: 'harvesting',
        field: 'Number of labours (Male)',
        field_key: 'no_male_workers',
        type: 'numeric',
    },
    {
        id: 9.11,
        section: 'harvesting',
        field: 'Number of labours (Female)',
        field_key: 'no_female_workers',
        type: 'numeric',
    },
    {
        id: 9.12,
        section: 'harvesting',
        field: 'Date of activity',
        field_key: 'activity_work_date',
        type: 'date',
    },
    {
        id: 9.13,
        section: 'harvesting',
        field: 'Number of hours worked',
        field_key: 'hours_worked',
        type: 'text',
    },
    {
        id: 9.14,
        section: 'harvesting',
        field: 'Total amount paid',
        field_key: 'total_amount_paid',
        type: 'numeric',
    },
    {
        id: 9.07,
        section: 'harvesting',
        field: 'Harvesting method',
        field_key: 'harvesting_method',
        type: 'dropdown',
    },
    {
        id: 9.08,
        section: 'harvesting',
        field: 'Amount spent',
        field_key: 'amount_spent',
        type: 'numeric',
    },
    {
        id: 9.17,
        section: 'harvesting',
        field: 'Machinery details',
        field_key: 'machinery_usage',
        type: 'table',
        dependent_field: 'harvesting_method',
        dependent_value: 'machinery',
        table_headers: ['Machinery used', 'Machinery Usage hours', 'Machinery cost', 'Machinery usage date'],
        table_body: [
            {
                name: 'machinery_used',
                type: 'dropdown',
                field_key: 'machinery_used',
            }, 
            {
                name: 'machinery_usage_hours',
                type: 'numeric',
                field_key: 'machinery_usage_hours',
            },
            {
                name: 'machinery_cost',
                type: 'numeric',
                field_key: 'machinery_cost'
            }, 
            {
                name: 'machinery_use_date',
                type: 'date',
                field_key: 'machinery_use_date'
            },
        ]
    },

]

export default FarmPractices